import { Toast } from "../shared/Toast";

// Legacy fallback used when the async Clipboard API is unavailable or blocked
// by a Permissions Policy (e.g. Chrome inside an iframe throws NotAllowedError).
const execCommandCopy = (text) => {
    if (!document.queryCommandSupported || !document.queryCommandSupported("copy")) {
        return false;
    }

    const textarea = document.createElement("textarea");

    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "0";
    textarea.style.width = "2em";
    textarea.style.height = "2em";
    textarea.style.padding = 0;
    textarea.style.border = "none";
    textarea.style.outline = "none";
    textarea.style.boxShadow = "none";
    textarea.style.background = "transparent";

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    let succeeded = false;
    try {
        succeeded = document.execCommand("copy");
    } catch (e) {
        succeeded = false;
    }
    document.body.removeChild(textarea);
    return succeeded;
};

export const copyToClipboard = async (text) => {
    const onSuccess = () => {
        Toast("success", "Text Copied To Clipboard");
    };
    const onError = (error) => {
        Toast("error", "Failed To Copy Text");
        throw error || new Error("Failed to copy text");
    };

    // Prefer the async Clipboard API, but fall back to execCommand when it is
    // blocked by a Permissions Policy or otherwise throws.
    if (typeof navigator !== "undefined" && navigator.clipboard && navigator.clipboard.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            onSuccess();
            return;
        } catch (e) {
            if (execCommandCopy(text)) {
                onSuccess();
                return;
            }
            onError(e);
            return;
        }
    }

    if (execCommandCopy(text)) {
        onSuccess();
        return;
    }
    onError(new Error("None of copying methods are supported by this browser!"));
};
